import { handleActions } from "redux-actions";
import {
  SEND_FIND_PASSWORD_CODE,
  SEND_FIND_PASSWORD_CODE_SUCCESS,
  SEND_FIND_PASSWORD_CODE_FAILURE,
  SEND_FIND_PASSWORD_CODE_INIT,
  RESET_PASSWORD_BY_CODE,
  RESET_PASSWORD_BY_CODE_SUCCESS,
  RESET_PASSWORD_BY_CODE_FAILURE,
  RESET_PASSWORD_BY_CODE_INIT
} from "../actionCreators";

const initialState = {
  isSending: false,
  isCodeSent: false,
  sendError: null,

  isResetting: false,
  isReset: false,
  resetError: null
};

const findPasswordReducer = handleActions(
  {
    [SEND_FIND_PASSWORD_CODE]: state => ({
      ...state,
      isSending: true,
      isCodeSent: false,
      sendError: null
    }),
    [SEND_FIND_PASSWORD_CODE_SUCCESS]: state => ({
      ...state,
      isSending: false,
      isCodeSent: true,
      sendError: null
    }),
    [SEND_FIND_PASSWORD_CODE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      isSending: false,
      isCodeSent: false,
      sendError: error
    }),
    [SEND_FIND_PASSWORD_CODE_INIT]: state => ({
      ...state,
      isSending: false,
      isCodeSent: false,
      sendError: null
    }),

    [RESET_PASSWORD_BY_CODE]: state => ({
      ...state,
      isResetting: true,
      isReset: false,
      resetError: null
    }),
    [RESET_PASSWORD_BY_CODE_SUCCESS]: state => ({
      ...state,
      isResetting: false,
      isReset: true,
      resetError: null
    }),
    [RESET_PASSWORD_BY_CODE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      isResetting: false,
      isReset: false,
      resetError: error
    }),
    [RESET_PASSWORD_BY_CODE_INIT]: state => ({
      ...state,
      isResetting: false,
      isReset: false,
      resetError: null
    })
  },
  initialState
);

export default findPasswordReducer;
